import React, { ReactElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import i18next from 'i18next';

import LanguageIcon from '../../../assets/icons/LanguageIcon';

import { setCurrentLanguage } from '../../../redux/actions/currentLanguage.actions';

import { selectCurrentLanguage } from '../../../redux/selectors';

import { Language } from '../../../types';

import { mergeClassNames } from '../../../utils';

import { LANGUAGE_DISPLAY_ENGLISH, LANGUAGE_DISPLAY_SPANISH, LANGUAGE_ENGLISH, LANGUAGE_SPANISH, LOCALE_EN_US, LOCALE_ES_MX } from '../../../constants';

import styles from './LanguageToggle.css';

const LanguageToggle = (): ReactElement => {
  const currentLanguage = useSelector(selectCurrentLanguage);

  const dispatch = useDispatch();

  // Add mapping helper
  const languageToLocale = (language: Language): string => {
    return language === LANGUAGE_ENGLISH ? LOCALE_EN_US : LOCALE_ES_MX;
  };

  const assignLanguage = (language: Language) => {
    i18next.changeLanguage(languageToLocale(language));
    dispatch(setCurrentLanguage(language));
  };

  return (
    <div className={styles.ovalRow}>
      <div 
        className={mergeClassNames(styles.languageButton, currentLanguage === LANGUAGE_ENGLISH && styles.selected)} 
        onClick={() => {
          assignLanguage(LANGUAGE_ENGLISH);
        }}
      >
        <LanguageIcon isSelected={currentLanguage === LANGUAGE_ENGLISH} />
        <span className={styles.languageTitle}>{LANGUAGE_DISPLAY_ENGLISH}</span>
      </div>
      <div 
        className={mergeClassNames(styles.languageButton, currentLanguage === LANGUAGE_SPANISH && styles.selected)} 
        onClick={() => {
          assignLanguage(LANGUAGE_SPANISH);
        }}
      >
        <LanguageIcon isSelected={currentLanguage === LANGUAGE_SPANISH} />
        <span className={styles.languageTitle}>{LANGUAGE_DISPLAY_SPANISH}</span>
      </div>
    </div>
  )
};

export default LanguageToggle;
